<template>
  <div align="center">
    <!--------------------推送banner start----------------------->
    <el-carousel indicator-position="outside" style="width: 300px;position: relative;"
                 :autoplay="false" height="430px">
      <el-carousel-item v-for="item in banners" :key="item.id">
        <a :href="item.jumpUrl" target="_blank">
          <img :src="item.path" style="width: 330px;height: 430px;opacity: 1;">
        </a>
        <h3>{{ item.name }}</h3>
      </el-carousel-item>
    </el-carousel>
    <!--------------------推送banner end----------------------->
    <!----------------------设置 start------------------------->
    <!--<div :style="{'margin-top': computedTop+'px'}" class="banner-foot">-->
    <div class="banner-foot">
      <div>
        <el-progress :percentage="netDiskSpaceUsedRate"></el-progress>
        <span style="font-size: 12px;">总容量{{netDiskSpace}},已使用{{netDiskUsedSpace}}</span>
        <!--<span style="font-size: 12px;">10G/50G</span>-->
        <!--<span style="font-size: 12px;color:#409EFF">扩容至2T</span>-->
      </div>
      <!--<div style="margin-top: 12px" align="center">-->
        <!--<div style="width: 180px;height: 30px;border: solid 0.5px gainsboro;line-height: 30px;">-->
          <!--<i class="el-icon-service"></i>-->
          <!--<span style="font-size: 14px;color: #409EFF;">在线咨询</span>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <!-----------------------设置 end-------------------------->
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      computedTop: window.innerHeight - 590 - 56 * 4,
      baseUrl: 'static/img/'
    }
  },
  computed: {
    ...mapState(['computedHeight', 'computedWidth', 'tagsList', 'rootFile', 'banners', 'netDiskSpaceUsed']),
    netDiskSpaceUsedRate () {
      if (!this.netDiskSpaceUsed || this.netDiskSpaceUsed === null) {
        return 0
      }
      let val = (this.netDiskSpaceUsed.netDiskUsedSpace / this.netDiskSpaceUsed.netDiskSpace).toFixed(2) * 100
      return val
    },
    netDiskUsedSpace () {
      if (!this.netDiskSpaceUsed || this.netDiskSpaceUsed === null) {
        return 0
      }
      return this.getFileSize(this.netDiskSpaceUsed.netDiskUsedSpace)
    },
    netDiskSpace () {
      if (!this.netDiskSpaceUsed || this.netDiskSpaceUsed === null) {
        return 0
      }
      return this.getFileSize(this.netDiskSpaceUsed.netDiskSpace)
    }
  }
}
</script>

<style scoped>
  .banner-foot {
    bottom: 20px;
    position: absolute;
    width: 75%;
    margin-left: 12%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue